
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"#c1c7d0"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12z"}}),_c('path',{attrs:{"d":"M19.5 12c0-.9-.6-1.7-1.5-1.9-.2-3.1-2.8-5.6-6-5.6S6.2 7 6 10.1c-.9.2-1.5 1-1.5 1.9 0 1 .7 1.8 1.7 2 .6 2.8 3 5.5 5.8 5.5s5.2-2.7 5.8-5.5c1-.2 1.7-1 1.7-2z","fill":"#f4f5f7"}}),_c('path',{staticClass:"st0",attrs:{"d":"M12 16.9c-1 0-2-.7-2.3-1.6-.1-.3 0-.5.3-.6.3-.1.5 0 .6.3.2.6.8 1 1.4 1 .6 0 1.2-.4 1.4-1 .1-.3.4-.4.6-.3.3.1.4.4.3.6-.3.9-1.3 1.6-2.3 1.6z"}})])
          )
        }
      }
    